import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid } from '@mui/material';
import { useFinOpsTab } from 'Context/contexts/FinOpsTabContext';
import AreaInfoWidget from 'components/Widgets/AreaInfoWidget';
import InprogressWidget from 'components/Widgets/InprogressWidget';
import { addOrUpdateInsights, deleteInsights, getFinopsTotalCostDetails, getInsights, getPlatformCostDetails } from 'service/service';
import { formatNumberWithCommas } from 'utils/common-util';
import Insights from 'components/DataEstate/Insights';
import '../FineOps/finops.scss';
import PieInsightInfoWidget from 'components/Widgets/PieInsightInfoWidget';
import PageWrapper from 'components/Common/PageWraper';
import { useFinOpsDrawer } from 'Context/contexts/FinOpsDrawerContext';
import HighlightedText from 'components/GlobalSearch/HighlightText';
import { useTheme } from "@mui/material/styles";

const FinOpsMetrics = () => {
	const theme = useTheme();
	const colors = theme.palette;
	const [azureCostData, setAzureCostData] = useState([]);
	const [integrationData, setIntegrationData] = useState<any>([]);
	const [visualizationData, setVisualizationData] = useState<any>([]);
	const [virtualizationData, setVirtualizationData] = useState<any>([]);
	const [otherPlatformsCostData, setOtherPlatformsCostData] = useState<any>([]);
	const [otherPlatforms, setOtherPlatforms] = useState('');
	const [, setotherPlatformsCostChange] = useState('-');
	const [otherPlatformsLoading, setOtherPlatformsLoading] = useState(true);
	const [otherPlatformsLoader, setOtherPlatformsLoader] = useState(false);
	const [onPremCloudData, setOnPremCloudData] = useState<any>([]);
	const [onPremCloud, setOnPremCloud] = useState('');
	const [, setOnPremCloudCostChange] = useState('-');
	const [onPremCloudCostLoading, setOnPremCloudCostLoading] = useState(true);
	const [onPremCloudCostLoader, setOnPremCloudCostLoader] = useState<boolean>(false);
	const [onPremInsights, setOnPremInsights] = useState<Insights[]>([]);
	const [otherPlatformsInsights, setOtherPlatformsInsights] = useState<Insights[]>([]);
	const [cloudCostYTD, setCloudCostYTD] = useState('');
	const [integration, setIntegration] = useState('');
	const [visual, setVisual] = useState('');
	const [virtual, setVirtual] = useState('');
	const [, setCostChange] = useState('-');
	const [, setIntCostChange] = useState('-');
	const [, setVisualCostChange] = useState('-');
	const [, setVirtualCostChange] = useState('-');
	const [azureCostLoading, setAzureCostLoading] = useState(true);
	const [integrationLoading, setIntegrationLoading] = useState(true);
	const [visualizationLoading, setVisualizationLoading] = useState(true);
	const [virtualizationLoading, setVirtualizationLoading] = useState(true);
	const [azureLoader, setAzureLoader] = useState<boolean>(false);
	const [intLoader, setIntLoader] = useState<boolean>(false);
	const [visualLoader, setVisualLoader] = useState<boolean>(false);
	const [virtualLoader, setVirtualLoader] = useState<boolean>(false);
	const { setHasFilters, setOnFiltersOpen } = useFinOpsTab();
	const navigate = useNavigate();

	useEffect(() => {
		setHasFilters(false);
		setOnFiltersOpen(() => {});
	}, []);
	const [azureInsights, setAzureInsights] = useState<Insights[]>([]);
	const [integrationInsights, setIntegrationInsights] = useState<Insights[]>([]);
	const [visualInsights, setVisualInsights] = useState<Insights[]>([]);
	const [virtualInsights, setVirtualInsights] = useState<Insights[]>([]);
	const [, setTotalCost] = useState('');
	const [, setTotalCostChange] = useState('-');
	const [, setSoftwareCost] = useState('');
	const [, setSoftwareCostChange] = useState('-');
	const [, setHardwareCost] = useState('');
	const [, setHardwareCostChange] = useState('-');
	const [, setLaborCost] = useState('');
	const [, setLaborCostChange] = useState('-');

	const { openDrawer } = useFinOpsDrawer();

	const widgetParam = ['Azure Cost', 'Integration Platform', 'Visualization Platform', 'Virtualization Platform', 'Other Platforms', 'onPrem Vs Cloud'];

	const colorMapping = {
		'Tibco': '#009BD8',
		'Kafka': '#28A745',
		'Informatica': '#FFC107',
		'ECG': '#FD783B',
		'MDT': '#8884D8',
		'MQ': '#FFB394',
		'WebLogic': '#A9ADCB99',
	};
	
	const gradientMapping = {
		'Tibco': { top: '#00B4C599', bottom: '#00B4C51A' },
		'Kafka': { top: '#00BF7D99', bottom: '#00BF7D1A' },
		'Informatica': { top: '#F5760099', bottom: '#F576001A' },
		'ECG': { top: '#E6308A99', bottom: '#E6308A1A' },
		'MDT': { top: '#8884D8', bottom: '#3C3A91' },
		'MQ': { top: '#FFB394', bottom: '#C76B4C' },
		'WebLogic': { top: '#A9ADCB99', bottom: '#A9ADCB1A' },
	};
	
	const colorMappingVisual = {
		'Tableau': '#009BD8',
		'PowerBI': '#28A745',
		'Tellius': '#FFC107',
	};
	
	const gradientMappingVisual = {
		'Tableau': { top: '#00B4C599', bottom: '#00B4C51A' },
		'PowerBI': { top: '#00BF7D99', bottom: '#00BF7D1A' },
		'Tellius': { top: '#F5760099', bottom: '#F576001A' },
	};

	const colorMappingAzure = {
		'value': '#009BD8',
	};
	
	const gradientMappingAzure = {
		'value': { top: '#00B4C599', bottom: '#00B4C51A' },
	};
	
	const colorMappingVirtual = {
		'Denodo': '#009BD8',
		'Presto': '#28A745',
	};
	
	const gradientMappingVirtual = {
		'Denodo': { top: '#009BD8', bottom: '#053367' },
		'Presto': { top: '#28A745', bottom: '#00D08D1A' },
	};

	const colorMappingOtherPlatforms = {
		'Alteryx': '#009BD8',
		'Rstudio': '#28A745',
	};
	
	const gradientMappingOtherPlatforms = {
		'Alteryx': { top: '#00B4C599', bottom: '#00B4C51A' },
		'Rstudio': { top: '#00BF7D99', bottom: '#00BF7D1A' },
	};

	const onPremCloudCostColorMapping = {
        'onPrem': '#299BFF',
        'Cloud': '#01C008',
    };
	  

	function formatAbsNumber(number: any) {
		if (number != null && !isNaN(number) && number != 0) {
			const absNumber = Math.abs(number);
        	return absNumber % 1 === 0 
            	? absNumber.toLocaleString('en-US', { maximumFractionDigits: 0 }) // No decimals for whole numbers
            	: absNumber.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); // Show decimals if needed
    	} 
		return '0';
	}

	const formatNumberByUnits = (number: number) => {
		if (number >= 1000000) {
			return `${new Intl.NumberFormat(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(
				number / 1000000
			)} MM`;
		}
		if (number >= 1000) 
			return `${formatNumberWithCommas((number / 1000).toFixed(2), true)} K`;
		return new Intl.NumberFormat(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(number);
	};

	const fetchCostDetails = async () => {
		//Fetch all required data concurrently
		const [azureRes, integrationRes, visualizationRes, virtualizationRes, otherPlatformsRes, onPremVsCloudRes, totalCostRes] =
			await Promise.all([
				getPlatformCostDetails('Azure'),
				getPlatformCostDetails('Integration'),
				getPlatformCostDetails('Visualization'),
				getPlatformCostDetails('Virtualization'),
				getPlatformCostDetails('Other Platforms'),
				getPlatformCostDetails('onPrem Vs Cloud'),
				getFinopsTotalCostDetails()
			]);
		if (azureRes.success) {
			const ytdCount = azureRes?.data?.ytd[0]?.KPI_VALUE ?? 0;
			setCloudCostYTD(formatNumberByUnits(ytdCount));

			const lmcgCount = azureRes?.data?.lmcg[0]?.KPI_VALUE ?? 0;
			setCostChange(lmcgCount.toString());

			setAzureCostData(azureRes.data.programCost);
			setAzureCostLoading(false);
		}
		if (integrationRes.success) {
			const ytdCount = integrationRes?.data?.ytd[0]?.KPI_VALUE ?? 0;
			setIntegration(formatNumberByUnits(ytdCount));

			const lmcgCount = integrationRes?.data?.lmcg[0]?.lmcg ?? 0;
			setIntCostChange(lmcgCount.toString());

			const intData = integrationRes?.data?.programCost || [];
			setIntegrationData(intData);
			setIntegrationLoading(false);
		}
		if (visualizationRes.success) {
			const ytdCount = visualizationRes?.data?.ytd[0]?.KPI_VALUE ?? 0;
			setVisual(formatNumberByUnits(ytdCount));

			const lmcgCount = visualizationRes?.data?.lmcg[0]?.lmcg ?? 0;
			setVisualCostChange(lmcgCount.toString());

			const visData = visualizationRes?.data?.programCost || [];
			setVisualizationData(visData);
			setVisualizationLoading(false);
		}
		if (virtualizationRes.success) {
			const ytdCount = virtualizationRes?.data?.ytd[0]?.KPI_VALUE ?? 0;
			setVirtual(formatNumberByUnits(ytdCount));

			const lmcgCount = virtualizationRes?.data?.lmcg[0]?.lmcg ?? 0;
			setVirtualCostChange(lmcgCount.toString());

			const virData = virtualizationRes?.data?.programCost || [];
			setVirtualizationData(virData);
			setVirtualizationLoading(false);
		}
		if (otherPlatformsRes.success) {
			const ytdCount = otherPlatformsRes?.data?.ytd[0]?.KPI_VALUE ?? 0;
			setOtherPlatforms(formatNumberByUnits(ytdCount));

			const lmcgCount = otherPlatformsRes?.data?.lmcg[0]?.lmcg ?? 0;
			setotherPlatformsCostChange(lmcgCount.toString());

			const otherData = otherPlatformsRes?.data?.programCost || [];
			setOtherPlatformsCostData(otherData);
			setOtherPlatformsLoading(false);
		}
		if (onPremVsCloudRes.success) {
			const ytdCount = onPremVsCloudRes?.data?.ytd[0]?.KPI_VALUE ?? 0;
			setOnPremCloud(formatNumberByUnits(ytdCount));

			const lmcgCount = onPremVsCloudRes?.data?.lmcg[0]?.lmcg ?? 0;
			setOnPremCloudCostChange(lmcgCount.toString());

			if (onPremVsCloudRes?.data?.programCost) {
				if (onPremVsCloudRes?.data?.programCost?.length > 0) {
					const item = onPremVsCloudRes?.data?.programCost[0]
					const onPremData = [
					  { name: 'OnPrem', value: item.OnPrem, formattedName: `$${formatNumberByUnits(item.OnPrem)}` },
					  { name: 'Cloud', value: item.Cloud, formattedName: `$${formatNumberByUnits(item.Cloud)}` },
					];
			  
					setOnPremCloudData(onPremData)
				}else{
					setOnPremCloudData([
					{ name: 'OnPrem', value: 0, formattedName: `0` },
					{ name: 'Cloud', value: 0, formattedName: `0` }])
				}
			}
			setOnPremCloudCostLoading(false);
		}
		if (totalCostRes.success) {
			const data = totalCostRes.data;

			const total = data.totalCostDetail?.find((item: any) => item.type === 'Total');
			const totalChange = data.lmcg?.find((item: any) => item.type === 'Total');

			const software = data.totalCostDetail?.find((item: any) => item.type === 'Software');
			const softwareChange = data.lmcg?.find((item: any) => item.type === 'Software');

			const hardware = data.totalCostDetail?.find((item: any) => item.type === 'Hardware');
			const hardwareChange = data.lmcg?.find((item: any) => item.type === 'Hardware');

			const labor = data.totalCostDetail?.find((item: any) => item.type === 'Labour');
			const laborChange = data.lmcg?.find((item: any) => item.type === 'Labour');

			const ytdCount = total?.totalCostYTD ?? 0;
			setTotalCost(formatNumberByUnits(ytdCount));
			const lmcgCount = totalChange?.growthPercentage ?? 0;
			setTotalCostChange(lmcgCount.toString());

			const softwareYTDCount = software?.totalCostYTD ?? 0;
			setSoftwareCost(formatNumberByUnits(softwareYTDCount));
			const softwarelmcgCount = softwareChange?.growthPercentage ?? 0;
			setSoftwareCostChange(softwarelmcgCount.toString());

			const hardwareYTDCount = hardware?.totalCostYTD ?? 0;
			setHardwareCost(formatNumberByUnits(hardwareYTDCount));
			const hardwarelmcgCount = hardwareChange?.growthPercentage ?? 0;
			setHardwareCostChange(hardwarelmcgCount.toString());

			const laborYTDCount = labor?.totalCostYTD ?? 0;
			setLaborCost(formatNumberByUnits(laborYTDCount));
			const laborlmcgCount = laborChange?.growthPercentage ?? 0;
			setLaborCostChange(laborlmcgCount.toString());
		}
	};

	const handleNavigate = (chartType: any = null) => {
		let path = '';
		if (chartType === 1)
			path = `/D&AIXOps/finopsMetrics/insightView?type=${widgetParam[1]}`;
		else if (chartType === 2)
			path = `/D&AIXOps/finopsMetrics/insightView?type=${widgetParam[2]}`;
		else if (chartType === 3)
			path = `/D&AIXOps/finopsMetrics/insightView?type=${widgetParam[3]}`;
		else if (chartType === 4)
			path = `/D&AIXOps/finopsMetrics/insightView?type=${widgetParam[4]}`;
		else if (chartType === 5)
			path = `/D&AIXOps/finopsMetrics/insightView?type=${widgetParam[5]}`;
		else
			path = `/finops/executive-dashboard`;
		navigate(path);
	};

	const setDataForChart = (chartId: number, data: any) => {
		switch (chartId) {
			case 0:
				setAzureInsights(data);
				break;
			case 1:
				setIntegrationInsights(data);
				break;
			case 2:
				setVisualInsights(data);
				break;
			case 3:
				setVirtualInsights(data);
				break;
			case 4:
				setOtherPlatformsInsights(data);
				break;
			case 5:
				setOnPremInsights(data);
				break;
		}
	};

	const setLoaderForChart = (chartId: number, isLoading: boolean) => {
		switch (chartId) {
			case 0:
				setAzureLoader(isLoading);
				break;
			case 1:
				setIntLoader(isLoading);
				break;
			case 2:
				setVisualLoader(isLoading);
				break;
			case 3:
				setVirtualLoader(isLoading);
				break;
			case 4:
				setOtherPlatformsLoader(isLoading);
				break;
			case 5:
				setOnPremCloudCostLoader(isLoading);
				break;
		}
	};

	// Function to handle adding a new insight
	const handleAddInsight = async (newInsight: any, chartId: any) => {
		try {
			setLoaderForChart(chartId, true);
			const xopsType = widgetParam[chartId] ?? widgetParam[5];

			const response = await addOrUpdateInsights({
				title: newInsight?.title,
				xopsType: xopsType,
				description: newInsight?.description
			});
			if (response.success) {
				fetchInsights(chartId);
			} else {
				setLoaderForChart(chartId, false);
			}
		} catch (error) {
			console.error('Failed to add insight:', error);
		}
	};
		
	// Function to handle updating an insight
	const handleUpdateInsight = async (updatedInsight: any, chartId: any) => {
		try {
			setLoaderForChart(chartId, true);
			//Fetch all required data concurrently
			const xopsType = widgetParam[chartId] ?? widgetParam[5];
			const response = await addOrUpdateInsights({
					title: updatedInsight?.title,
					xopsType: xopsType,
					description: updatedInsight?.description,
					insight_id: updatedInsight?.id
				});
			if (response.success) {
				fetchInsights(chartId);
			} else {
				setLoaderForChart(chartId, false);
			}
		} catch (error) {
			console.error('Failed to update insight:', error);
		}
	};
		
	// Function to handle deleting an insight
	const handleDeleteInsight = async (insightId: number, chartId: any) => {
		try {
			setLoaderForChart(chartId, true);
			const response = await deleteInsights(insightId);
			if (response.success) {
				fetchInsights(chartId);
			} else {
				setLoaderForChart(chartId, false);
			}
		} catch (error) {
			console.error('Failed to delete insight:', error);
		}
	};

	//Function to fetch insights
	const fetchInsights = async (chartId: any) => {
		setLoaderForChart(chartId, true);
		try {
			const response = await getInsights(widgetParam[chartId]);
			if (response.success) {
				setDataForChart(chartId, response.data.data)
				setLoaderForChart(chartId, false);
			} else {
				setLoaderForChart(chartId, false);
			}
		} catch (error) {
			console.error('Failed to get insights:', error);
		}
	};

	// Fetch insights
	useEffect(() => {
		fetchCostDetails();
		fetchInsights(0);
	}, []);

	useEffect(() => {
		const activeId = document.getElementById('root');
		if (window.location.pathname === '/finops/executive') {
			if (activeId) {
				document.head.classList.add('theme-bg-blue');
				document.body.classList.add('theme-bg-blue');
				activeId.classList.remove('root');
			}
		} else {
			if (activeId) {
				activeId.classList.add('root');
			}
		}
		return () => {
			document.head.classList.remove('theme-bg-blue');
			document.body.classList.remove('theme-bg-blue');
			const activeId = document.getElementById('root');
			if (activeId) activeId.classList.add('root');
		};
	}, []);

	
	return (
		<PageWrapper sx={{ mt: 0, pt: '36px !important', px: '32px !important' }}>
			<Grid container spacing={2} marginTop="1rem">
			{/* <Grid item xs={12}>
				<NumberWidget
					title="Total Cost"
					minTitleHeight= '23px'
					number={'$' + totalCost}
					isLoading={!totalCost}
					tooltipLabel={''}
					hasTooltip={false}
					change={formatAbsNumber(totalCostChange)}
					changeType={
						totalCostChange === null || totalCostChange === undefined
							? ''
							: parseFloat(totalCostChange) > 0.0
							? 'increase'
							: parseFloat(totalCostChange) < 0.0
							? 'decrease'
							: ''
					}
				/>
			</Grid> */}
			{/* <Grid item lg={4} md={4} xs={12}>
				<NumberWidget
					// bgColor= {selectedWidget === 'Software Cost' ? '#001E3E' : ''}
					minTitleHeight= '23px'
					title="Software Cost"
					// selectedTitle={selectedWidget}
    				// handleEvent={() => setSelectedWidget('Software Cost')}
					number={'$' + softwareCost}
					isLoading={!softwareCost}
					tooltipLabel=""
					hasTooltip={false}
					change={formatAbsNumber(softwareCostChange)}
					changeType={
						softwareCostChange == null
						? ''
						: parseFloat(softwareCostChange) > 0
						? 'increase'
						: parseFloat(softwareCostChange) < 0
						? 'decrease'
						: ''
					}
				/>
			</Grid> */}
			{/* <Grid item lg={4} md={4} xs={12}>
				<InprogressWidget title={'Hardware Cost'} tooltipLabel="Development In Progress" height='100px' bgColor='#002349'/>
				<NumberWidget
					// bgColor= {selectedWidget === 'Hardware Cost' ? '#001E3E' : ''}
					minTitleHeight= '23px'
					title="Hardware Cost"
					selectedTitle={selectedWidget}
    				// handleEvent={() => setSelectedWidget('Hardware Cost')}
					number={'$' + hardwareCost}
					isLoading={!hardwareCost}
					tooltipLabel=""
					hasTooltip={false}
					change={formatAbsNumber(hardwareCostChange)}
					changeType={
						hardwareCostChange == null
						? ''
						: parseFloat(hardwareCostChange) > 0
						? 'increase'
						: parseFloat(hardwareCostChange) < 0
						? 'decrease'
						: ''
					}
				/>
			</Grid> */}

			{/* <Grid item lg={4} md={4} xs={12}>
				<InprogressWidget title={'Labor Cost'} tooltipLabel="Development In Progress" height='100px' bgColor='#002349'/>
				<NumberWidget
					// bgColor= {selectedWidget === 'Labour Cost' ? '#001E3E' : ''}
					minTitleHeight= '23px'
					title="Labor Cost"
					selectedTitle={selectedWidget}
    				// handleEvent={() => setSelectedWidget('Labor Cost')}
					number={'$' + laborCost}
					isLoading={!laborCost}
					tooltipLabel=""
					hasTooltip={false}
					change={formatAbsNumber(laborCostChange)}
					changeType={
						laborCostChange == null
						? ''
						: parseFloat(laborCostChange) > 0
						? 'increase'
						: parseFloat(laborCostChange) < 0
						? 'decrease'
						: ''
					}
				/>
			</Grid> */}
			
			{/* <Grid item xs={12}>
				<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: '16px' }}>
					<Typography sx={{ color: '#009BDB', fontSize: '16px', fontWeight: 600 }}>
					{selectedWidget} Breakup
					</Typography>
					<Divider sx={{ flexGrow: 1, backgroundColor: '#009BDB', marginLeft: 1 }} />
				</Box>
			</Grid> */}
		
				<Grid item xs={12} md={12} lg={12} id="azure-cost">
					<AreaInfoWidget
						titleText="Azure Cost"
						title={<HighlightedText text= "Azure Cost"/>}
						data={azureCostData}
						value={cloudCostYTD}
						change={0}
						changeType=''
						// change={formatAbsNumber(costChange)}
						// changeType={costChange === null || costChange === undefined
						// 	? ''
						// 	: parseFloat(costChange) > 0.0
						// 	? 'increase'
						// 	: parseFloat(costChange) < 0.0
						// 	? 'decrease'
						// 	: ''}
						colorMapping={colorMappingAzure}
						gradientMapping={gradientMappingAzure}
						isLoading={azureCostLoading}
						hasLegend = {false}
						handleEvent={() => handleNavigate()}
						loader = {azureLoader}
						fetchInsights = {() => fetchInsights(0)}
						insights={azureInsights}
						setInsights={setAzureInsights}
						onAdd={(newInsight) => handleAddInsight(newInsight, 0)}
						onUpdate={(newInsight) => handleUpdateInsight(newInsight, 0)}
						onDelete={(newInsight) => handleDeleteInsight(newInsight, 0)}
						openDrawer={openDrawer}
					/>
				</Grid>
				
				<Grid item xs={12} md={12} lg={12} id="data-viz-cost">
					<AreaInfoWidget
						titleText="Data Visualization Platform Cost"
						title={<HighlightedText text="Data Visualization Platform Cost" />}
						data={visualizationData}
						value={visual}
						change={0}
						changeType=''
						// change={formatAbsNumber(visualCostChange)}
						// changeType={visualCostChange === null || visualCostChange === undefined
						// 	? ''
						// 	: parseFloat(visualCostChange) > 0.0
						// 	? 'increase'
						// 	: parseFloat(visualCostChange) < 0.0
						// 	? 'decrease'
						// 	: ''}
						isLoading={visualizationLoading}
						colorMapping={colorMappingVisual} 
						gradientMapping={gradientMappingVisual} 
						hasLegend
						handleEvent={() => handleNavigate(2)}
						loader = {visualLoader}
						fetchInsights = {() => fetchInsights(2)}
						insights={visualInsights}
						setInsights={setVisualInsights}
						onAdd={(newInsight) => handleAddInsight(newInsight, 2)}
						onUpdate={(newInsight) => handleUpdateInsight(newInsight, 2)}
						onDelete={(newInsight) => handleDeleteInsight(newInsight, 2)}
						openDrawer={openDrawer}
					/>
				</Grid>
				<Grid item xs={12} md={12} lg={12} id="integration-cost">
					<AreaInfoWidget
						titleText="Integration (Informatica) Platform Cost"
						title={<HighlightedText text="Integration (Informatica) Platform Cost" />}
						data={integrationData}
						value={integration}
						change={0}
						changeType=''
						// change={formatAbsNumber(intCostChange)}
						// changeType={intCostChange === null || intCostChange === undefined
						// 	? ''
						// 	: parseFloat(intCostChange) > 0.0
						// 	? 'increase'
						// 	: parseFloat(intCostChange) < 0.0
						// 	? 'decrease'
						// 	: ''}
						isLoading={integrationLoading}
						colorMapping={colorMapping} 
						gradientMapping={gradientMapping} 
						hasLegend
						handleEvent={() => handleNavigate(1)}
						loader = {intLoader}
						fetchInsights = {() => fetchInsights(1)}
						insights={integrationInsights}
						setInsights={setIntegrationInsights}
						onAdd={(newInsight) => handleAddInsight(newInsight, 1)}
						onUpdate={(newInsight) => handleUpdateInsight(newInsight, 1)}
						onDelete={(newInsight) => handleDeleteInsight(newInsight, 1)}
						// customHeight={'445px'}
						openDrawer={openDrawer}
					/>
				</Grid>
				
				<Grid item xs={12} md={12} lg={12} id="virtualization-cost">
					<AreaInfoWidget
						titleText="Data Virtualization Platform Cost"
						title={<HighlightedText text="Data Virtualization Platform Cost" />}
						data={virtualizationData}
						value={virtual}
						change={0}
						changeType=''
						// change={formatAbsNumber(virtualCostChange)}
						// changeType={virtualCostChange === null || virtualCostChange === undefined
						// 	? ''
						// 	: parseFloat(virtualCostChange) > 0.0
						// 	? 'increase'
						// 	: parseFloat(virtualCostChange) < 0.0
						// 	? 'decrease'
						// 	: ''}
						isLoading={virtualizationLoading}
						colorMapping={colorMappingVirtual} 
						gradientMapping={gradientMappingVirtual} 
						hasLegend
						handleEvent={() => handleNavigate(3)}
						loader={virtualLoader}
						fetchInsights = {() => fetchInsights(3)}
						insights={virtualInsights}
						setInsights={setVirtualInsights}
						onAdd={(newInsight) => handleAddInsight(newInsight, 3)}
						onUpdate={(newInsight) => handleUpdateInsight(newInsight, 3)}
						onDelete={(newInsight) => handleDeleteInsight(newInsight, 3)}
						openDrawer={openDrawer}
					/>
				</Grid>
				<Grid item xs={12} md={12} lg={12} id="other-platforms-cost">
					<AreaInfoWidget
						titleText="Other Platforms Cost (YTD)"
						title={<HighlightedText text="Other Platforms Cost (YTD)" />}
						data={otherPlatformsCostData}
						value={otherPlatforms}
						change={0}
						changeType=''
						// change={formatAbsNumber(otherPlatformsCostChange)}
						// changeType={otherPlatformsCostChange === null || otherPlatformsCostChange === undefined
						// 	? ''
						// 	: parseFloat(otherPlatformsCostChange) > 0.0
						// 	? 'increase'
						// 	: parseFloat(otherPlatformsCostChange) < 0.0
						// 	? 'decrease'
						// 	: ''}
						isLoading={otherPlatformsLoading}
						colorMapping={colorMappingOtherPlatforms} 
						gradientMapping={gradientMappingOtherPlatforms} 
						hasLegend
						handleEvent={() => handleNavigate(4)}
						loader={otherPlatformsLoader}
						fetchInsights = {() => fetchInsights(4)}
						insights={otherPlatformsInsights}
						setInsights={setOtherPlatformsInsights}
						onAdd={(newInsight) => handleAddInsight(newInsight, 4)}
						onUpdate={(newInsight) => handleUpdateInsight(newInsight, 4)}
						onDelete={(newInsight) => handleDeleteInsight(newInsight, 4)}
						openDrawer={openDrawer}
					/>
				</Grid>
				<Grid item xs={12} md={12} lg={12} id="onprem-vs-cloud-cost">
					<PieInsightInfoWidget
						title={<HighlightedText text="OnPrem Vs Cloud Cost" />}
						value={onPremCloud}
						change={0}
						changeType={''}
						// change={formatAbsNumber(onPremCloudCostChange)}
						// changeType={onPremCloudCostChange === null || onPremCloudCostChange === undefined
						// 	? ''
						// 	: parseFloat(onPremCloudCostChange) > 0.0
						// 	? 'increase'
						// 	: parseFloat(onPremCloudCostChange) < 0.0
						// 	? 'decrease'
						// 	: ''}
						isLoading={onPremCloudCostLoading}
						seriesData={onPremCloudData}
						customSize="230px"
						showDollar={true}
						colorMapping={onPremCloudCostColorMapping}
						handleNavigate={() => handleNavigate(5)}
						radius={'65%'}
						customLegendPosition={true}
						customChartPosition = {['55%', '35%']}
						loader={onPremCloudCostLoader}
						fetchInsights = {() => fetchInsights(5)}
						insights={onPremInsights}
						setInsights={setOnPremInsights}
						onAdd={(newInsight) => handleAddInsight(newInsight, 5)}
						onUpdate={(newInsight) => handleUpdateInsight(newInsight, 5)}
						onDelete={(newInsight) => handleDeleteInsight(newInsight, 5)}
						openDrawer={openDrawer}
					/>
				</Grid>
				<Grid item xs={12}>
					<InprogressWidget title={<HighlightedText text="Other Tools Cost" />} tooltipLabel="Development In Progress" bgColor={colors.widget.background.card} textColor={colors.widget.text.title}/>
				</Grid>
			</Grid>
			{/* <FinOpsCostBreakupDrawer open={isDrawerOpen} onClose={() => {setIsDrawerOpen(false), setBreakupData([])}} title={drawerTitle} data={breakupData} loading={drawerLoading} /> */}
		</PageWrapper>
	);
};

export default FinOpsMetrics;

